import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getSubjectsList } from "examsbook-react-sdk/actions";
import useSelectedExam from "./useSelectedExam";

/**
 * get list of subjects
 * @returns {{subjects: *}}
 */
export default function useSubjectList() {
    const dispatch = useDispatch();
    const subjectList = useSelector((state) => state.subjectList);
    const selectedExam = useSelectedExam();
    useEffect(() => {
        if (selectedExam) {
            getSubjectListData();
        }
    }, [ selectedExam ]);

    function getSubjectListData() {
        dispatch(getSubjectsList(selectedExam._id));
    }

    return {
        subjectList
    };
}
